import types from './types';
import { createTestOverviewReducers } from '../../common/test-overview/reducers';

const { initialState, reducer } = createTestOverviewReducers(types);

export default reducer;
export { initialState };
